import { Component, EventEmitter, Input, Output } from '@angular/core';

export type AutoSaveStatus = 'saving' | 'saved' | 'error' | null;

@Component({
  selector: 'authority-labs-draft-toolbar',
  templateUrl: './draft-toolbar.component.html',
  styleUrls: ['./draft-toolbar.component.scss']
})
export class DraftToolbarComponent {
  @Input() autoSaveStatus: AutoSaveStatus = null;
  @Input() readonly = false;
  @Input() canUndo = false;
  @Input() canFinish = false;
  @Input() canReopen = false;
  @Input() draftClosed = false;
  @Input() hasInkData = false;
  @Input() recognizing = false;
  @Output() undoClick = new EventEmitter<void>();
  @Output() finishClick = new EventEmitter<void>();
  @Output() reopenClick = new EventEmitter<void>();
}
